import { ReactElement, ReactNode } from 'react';
import cx from 'clsx';
import type { IncompleteSupplier } from 'modules/supplier/supplier/types';
import { ProductTitle } from 'modules/supplier/products';
import { TitleContainer } from 'components/TitleContainer';
import { type StackProps, Stack, Box } from '@ff-it/ui';

type SupplierTitleProps = IncompleteSupplier &
  Omit<StackProps, 'children' | 'placeholder'> & { placeholder?: ReactNode; customProductName?: string };

export const supplierTitleHeader = (
  <Stack direction="horizontal">
    <Box width="3/5">
      <TitleContainer title="Outlet or service" subtitle="Product" />
    </Box>
    <Box width="2/5">
      <TitleContainer title="Provider" subtitle="Activity" />
    </Box>
  </Stack>
);

export function SupplierTitle({
  product,
  provider,
  className,
  activity,
  placeholder = '—',
  customProductName,
  ...rest
}: SupplierTitleProps): ReactElement {
  return (
    <Stack
      direction="horizontal"
      className={cx('supplier-title', className)}
      data-productid={product?.id}
      data-providerid={provider?.id}
      data-activityid={activity?.id}
      {...rest}
    >
      <Box width="1/2">
        {product ? (
          <ProductTitle product={product} customProductName={customProductName} />
        ) : (
          <TitleContainer title={customProductName || placeholder} />
        )}
      </Box>
      <Box width="1/2">
        <TitleContainer
          title={provider ? provider.internal_name : placeholder}
          subtitle={activity ? activity.name : placeholder}
        />
      </Box>
    </Stack>
  );
}
